import script from "./GasProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./GasProvider.vue?vue&type=script&setup=true&lang=ts"

import "./GasProvider.vue?vue&type=style&index=0&id=c5907ec8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5907ec8"]])

export default __exports__